module.exports = __webpack_public_path__ + "static/hero-background-f5c3f35d18c62f18c2f1f23dbb1a9ef2.jpg";